// extracted by mini-css-extract-plugin
export var root = "Services-module--root--1c5_i";
export var headingIllustration = "Services-module--headingIllustration--wBt2I";
export var mobile = "Services-module--mobile--1t4pT";